// Segmentos dinámicos de las rutas: la palabra clave y el valor que la sigue.
// Colapsamos ese valor a un placeholder en la ruta y lo extraemos como
// propiedad, para que Mixpanel agrupe la misma página entre plantas y
// dispositivos (p. ej. todos los "dashboard") sin perder el identificador
// concreto, que queda disponible como propiedad para filtrar.
const DYNAMIC_SEGMENTS: Record<
  string,
  { property: string; placeholder: string }
> = {
  plants: { property: "plant_id", placeholder: ":plantId" },
  ncu: { property: "ncu_name", placeholder: ":ncuName" },
  tcu: { property: "tcu_name", placeholder: ":tcuName" },
  hsu: { property: "hsu_name", placeholder: ":hsuName" },
};

interface NormalizedPath {
  path: string;
  params: Record<string, string>;
}

const normalizePath = (path: string): NormalizedPath => {
  const segments = path.split("/");
  const params: Record<string, string> = {};

  for (let i = 0; i < segments.length - 1; i++) {
    const rule = DYNAMIC_SEGMENTS[segments[i]];
    const value = segments[i + 1];
    if (rule && value) {
      params[rule.property] = value;
      segments[i + 1] = rule.placeholder;
    }
  }

  return { path: segments.join("/"), params };
};

// Hook before_track de Mixpanel: corre en cada track() —incluido autocapture—
// antes de armar el evento. Reescribe current_url_path con la ruta normalizada
// y añade los identificadores como propiedades. Devuelve [event_name, props].
export const normalizeEventPath = (
  eventName: string,
  properties?: Record<string, unknown>,
): [string, Record<string, unknown>] => {
  const currentPath = properties?.current_url_path;
  if (typeof currentPath !== "string") {
    return [eventName, properties ?? {}];
  }

  const { path, params } = normalizePath(currentPath);
  return [eventName, { ...properties, current_url_path: path, ...params }];
};
